import { atom, selector, useResetRecoilState} from "recoil"
import { News } from "../models/News"
import apiNews from "../services/api"
import { areeMySixtemaState } from "../utils/hooks"

export const notaOpRequestNumberState = atom({
    key: 'notaOpRequestNumberState',
    default: 1
})

export const notaOpState = selector({
    key: 'notaOpState',
    get: async ({get}) => {
        get(notaOpRequestNumberState)
        const options = get(notaOpOptionsState)
        const areeArray = get(areeMySixtemaState)
        const aree = areeArray.join(';') + ';'

        if(options.viewAll) {
            return apiNews.getAllNotaInformativa(aree, options.limit) ?? []
        } else {
            return apiNews.getValidNotaInformativa(aree, options.limit) ?? []
        }
    }
})

export const notaOpListAtom = atom<News[]>({
    key: 'notaOpListAtom',
    default: [],
})

export const defaultNotaOpAtom: News = {
    id: 0,
    userCre: '',
    dateCre: null,
    userUpd: '',
    dateUpd: null,
    title: '',
    subtitle: '',
    body: '',
    important: false,
    validUntil: '',
    aree: '',
    expired: false,
    notaOperativa: true,
    newsImage: null,
    fileEncoded: '',
    publish: true,
    notify: false,
    livelli: '',
    province: '',
    managed: null
}

export const notaOpAtom = atom<News>({
    key: 'notaOpAtom',
    default: defaultNotaOpAtom
})

export const useResetNotaOp = () => {
    return useResetRecoilState(notaOpAtom)
} 

//Used for update
// export const updateNotaInfSelector = selector<News>({
//     key: 'updateNotaInfSelector',
//     get: ({get}) => {
//         //const myList = get(newsListAtom).map(x => x)
//         //let rv = myList.find(x => x.id === item.id)
//         const rv = get(notaOpAtom)
//         return rv
//     },
//     set: ({get, set}, newValue) => {
//         if (!(newValue instanceof DefaultValue)) {
//             if (newValue) {
//                 const newSd = newValue as News
//                 const lista = get(notaOpListAtom)
//                 const ele = lista.find(x => x.id === newSd.id)
//                 if (ele) {
//                     //Sostituisco il News nell'indice
//                     const idx = lista.findIndex(x => x.id === ele.id)
//                     if (idx >= 0) {
//                         const newLista = [...lista.slice(0, idx), newSd, ...lista.slice(idx + 1)]
//                         set(notaOpListAtom, newLista)
//                     }
//                 }
//             }
//         }
//     }
// })

//For Add
// export const addNotaInfSelector = selector<News>({
//     key: 'addNotaInfSelector',
//     get: ({get}) => {
//         //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
//         return get(notaOpAtom)
//     },
//     set: ({get, set}, itemAdd) => {
//         set(notaOpListAtom, [...get(notaOpListAtom), itemAdd as News])
//     },
// })

// //For Delete
// export const deleteNotaInfSelector = selector<News>({
//     key: 'deleteNotaInfSelector',
//     get: ({get}) => {
//         //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
//         return get(notaOpAtom)
//     },
//     set: ({get, set}, itemToRemove) => {
//         // console.log('setting news removed')
//         let myNewList = get(notaOpListAtom).filter(x => x.id !== (itemToRemove as News).id)
//         set(notaOpListAtom, myNewList)
//     },
// })

// Opzioni per le note informative
export type NotaOpOptions = {
    viewAll: boolean,
    limit: number,
}

const initialNotaOpOptions: NotaOpOptions = {
    viewAll: false,
    limit: 20,
}

export const notaOpOptionsState = atom({
    key: 'notaOpOptionsState',
    default: initialNotaOpOptions
})
